var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgBrowser = function SvgBrowser(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Browser' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,41 L0,0 L48,0 L48,41 L0,41 Z M2,10 L46,10 L46,2 L2,2 L2,10 Z M2,39 L46,39 L46,12 L2,12 L2,39 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.104,4 4,3.104 4,2 C4,0.895 3.104,0 2,0 C0.896,0 0,0.895 0,2 C0,3.104 0.896,4 2,4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,4 C9.104,4 10,3.104 10,2 C10,0.895 9.104,0 8,0 C6.896,0 6,0.895 6,2 C6,3.104 6.896,4 8,4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,4 C15.104,4 16,3.104 16,2 C16,0.895 15.104,0 14,0 C12.896,0 12,0.895 12,2 C12,3.104 12.896,4 14,4"
  })));
};
SvgBrowser = pure(SvgBrowser);
SvgBrowser.displayName = 'SvgBrowser';
export default SvgBrowser;